import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NecUrl } from '../../../model/url/url';
import { Observable } from 'rxjs';



@Injectable()
export class NecXiaoXiangInterface {
  constructor(private http: HttpClient) {
  }

  /**
   * æ¥è¯¢æ½æ¹è¯¾ç¨
   */
  getXiaoXiangCourses(): Observable<any[]> {
    return this.http.get(NecUrl.SERVER_URL + '/server/meetingActivityInfos', {
      params: new HttpParams()
        .set('size', '10000')
        .set('resId', 'dept:-1')
    }).pipe(
      map((resp: any) => {
        return resp.content;
      })
    );
  }
}
